<template>
    <div>
        <div style="display: flex;justify-content: center;">

            <div style="width: 1200px;">
                <Bread :breads="breads" defaultType="2"></Bread>
                <div style="color: white;display: flex;justify-content: space-between;margin-top: 10px;">
<!--                    <img src="/static/img/zhuhai/机构图片.png" alt="">-->
<!--                    <div class="logo">-->
<!--                        <img :src="$getImage(platformInfo.img)" v-if="platformInfo.img" class="logo-img">-->
<!--                    </div>-->
                    <img :src="$getImage(platformInfo.img)" v-if="platformInfo.img" class="logo-img">


                    <div style="padding-left: 30px;">
                        <p class="platform-title">{{ platformInfo.platformName }}</p>
                        <p class="platform-desc">依托单位：{{ platformInfo.unitName }}</p>
                        <p class="platform-desc" style="height: 72px;">简介： {{platformInfo.briefIntroduction}}
                        </p>
                        <p class="platform-get-button">
                            <el-button style="background: #61CFAF;border-color: #61CFAF;color: white;" @click="getPlatformAdminPhone">获取该平台联系人电话</el-button>
                        </p>
                    </div>



                </div>


                <div class="platform-content-box" >
                    <div class="platform-card">

                        <div class="platform-card-content" :class="active === '1' ? 'active': ''" @click="change('1')">
                            <img src="/static/img/zhaoqing/科技政策.svg" alt="">
                            <div  style="padding-left: 20px;">
                                <p class="platform-title">机构介绍</p>
                                 <span class="platform-card-desc">机构的基本信息</span>
                            </div>
                        </div>
                        <div class="platform-card-content" :class="active === '2' ? 'active': ''" style="margin-left: 10px;"  @click="change('2')">
                            <img src="/static/img/zhaoqing/设备共享.svg" alt="">
                            <div  style="padding-left: 20px;">
                                <p class="platform-title">科研仪器</p>
                                <span class="platform-card-desc">{{ countData.countNumber }}台（套）</span>
                            </div>
                        </div>

                    </div>


                    <div class="res-content-box"  v-if="active === '1'">
                        <el-row>
                            <el-col :span="5">
                                <div>
                                    <div class="instrument-title">本机构最新科研仪器</div>
                                    <div height="400px" style="border: 1px solid #E7E7E7;">
                                        <p v-if="instrumentName.length > 0" class="instrument-name" v-for="(item,index) in instrumentName" :key="index" @click="gotoResDetail(item)">
                                            <span class="instrument-name-index"

                                                  :style="
                                                    index === 0 ? 'background-color: #E02222;' :
                                                    index === 1 ? 'background-color: #FA8131;' :
                                                    index === 2 ? 'background-color: #F7B500;' : ''
                                                    ">
                                                {{index+1}}
                                            </span>
                                            {{ item.cname }}

                                        </p>

                                        <el-empty v-else description="暂无数据" />
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="19" style="padding-left: 20px;" >
                                <div v-html="platformInfo.dataSystem">

                                </div>
                            </el-col>
                        </el-row>

                    </div>


                    <div class="res-content-box"   v-if="active === '2'" >
                        <el-row>
                            <el-col :span="5">
                                <div>
                                    <h3 class="text-center">资源分类</h3>


                                    <div class="instrument-title">科研仪器</div>
                                    <el-scrollbar height="400px" style="border: 1px solid #E7E7E7;">
                                        <el-tree
                                            v-loading="resLoading"
                                            :expand-on-click-node="false"
                                            :data="cascaderOptions"
                                            :props="treeProps"
                                            @node-click="(data,node,nodeItem)=>handleNodeClick(data,node,nodeItem)"
                                            accordion
                                        ></el-tree>

                                    </el-scrollbar>
                                </div>
                            </el-col>
                            <el-col :span="19" style="padding-left: 20px;" >
                                <div>

                                    <div style="display:flex; justify-content: space-between;">
                                        <p class="instrument-count">
                                            共<b style="color: #61CFAF;;"> {{ resListResult.total }} </b>个资源
                                            <el-tag
                                                v-if="treeClickNodeName"
                                                closable
                                                type="success"
                                                @close="nodeNameClose(tag)"
                                            >{{ treeClickNodeName }}</el-tag>
                                        </p>

                                        <el-input class="serach-input"
                                                  v-model="instrumentSearchForm.cname"
                                                  placeholder="请输入想浏览的仪器名称"
                                                  clearable
                                                  style="width:320px;height:40px;border: 2px solid #61CFAF;">
                                            <template #append>
                                                <el-button :icon="Search" @click="getResList"  style="background-color: #61CFAF;color: white;border-radius: 0px;height: 100%;width:40px;"/>
                                            </template>
                                        </el-input>
                                    </div>

                                    <div style="" v-loading="resLoading">
                                        <el-scrollbar style="border: 1px solid #E7E7E7;margin-top: 10px;min-height: 500px;" >
                                            <div  v-if="resListResult.total > 0" style="display: flex;justify-content: center" v-for="(item,index) in resListResult.list" :key="index">
                                                <div style="width: 95%;padding: 20px 0px;border-bottom: 1px dashed #E7E7E7;">
                                                    <p class="instrument-info-name" @click="gotoDetail(item)">{{ item.cname }}</p>
                                                    <div style="margin-top: 10px;">
                                                        <span class="instrument-info-field">更新时间：{{ item.createTime }}</span>
                                                        <span class="instrument-info-field">所属平台：<span style="color: #61CFAF;">{{ item.platformName }}</span></span>
                                                        <span class="instrument-info-field">所属单位：{{ item.unitName }}</span>
                                                    </div>
                                                    <div>
                                                        <span class="instrument-info-field">安放地市：{{ getCityNameByCodee(item.city) }}</span>
                                                    </div>
                                                </div>

                                            </div>
                                            <el-empty v-else description="暂无数据" />

                                        </el-scrollbar>
                                        <div style="display: flex;justify-content: center;margin-top: 25px;">
                                            <Pager
                                                @pageChange="pageChange"
                                                :layout="'total, prev, pager, next'"
                                                class="res-pager"
                                                :totalRecord="resListResult.total"
                                                :totalPage="resListResult.totalPage"
                                                :currentPage="currentPage"></Pager>
                                        </div>

                                    </div>

                                </div>
                            </el-col>
                        </el-row>

                    </div>
                </div>

            </div>


        </div>
    </div>
</template>

<script setup >

import {ref, toRefs, reactive, getCurrentInstance, onMounted} from 'vue'
import { Search,RefreshRight } from '@element-plus/icons-vue'
import Bread from "@/components/common/Bread.vue";
import {useRoute} from "vue-router";
import city from '../../city'
import Pager from "@/components/common/Pager.vue";

const {proxy} = getCurrentInstance();

const breads = ref([
    {text:'首页', path:'/zhaoqing/index'},
    {text:'实验室与平台基地', path:'/zhaoqing/zhaoqingPlatform'},
    {text:'机构详情'},
])

const props2 = {
    multiple: true,
    checkStrictly: true,
}

const active = ref('1')


const instrumentName = ref([])




const change = (val => {
    active.value = val
    if(val === '2'){
        getResList();
    }
})

const resLoading = ref(false);
const platformInfo = ref({})
const getInfo = (id) => {
    resLoading.value = true;

    proxy.$http.post('/gdsti2/web/a/webLab/platformInfo', {id: id}).then(res => {
        if (res.data.state == 0) {
            if(res.data.state === 0){
                platformInfo.value = res.data.result;
                getNewRes(id);
            }
        }
        resLoading.value = false;
    }).catch(err => {
        resLoading.value = false;
    });
}

const getNewRes = (id) => {
    //本机构最新仪器
    let param = {
        platformId: id,
        type:'new',
        noPage: 1,
        limit: 10
    }
    proxy.$http.post('/gdsti2/web/a/webResource/resourceDataList', param).then(res=>{
        if(res.data.state == 0){
            instrumentName.value = res.data.result;
        }
    }).catch(err=>{

    })
}

const getPlatformAdminPhone = () => {
    var userInfo = proxy.$store.state.userInfo;
    if (userInfo && userInfo.userCode) {

        proxy.$http.post('/gdsti2/lab/c/labPlatform/getPlatformPhone', {id: platformInfo.value.id}).then(res => {
            if (res.data.state == 0) {
                that.ElMessage.success(res.data.result);
            }
        }).catch(err => {
        })
    } else {
        proxy.ElMessage.error("请先登录");
    }
}

const gotoResDetail = (item) => {
    let param = {
        id: item.id,
        catalogType: item.catalogType
    }
    proxy.$router.push({path: '/zhuhai/zhuhaiInstrumentInfo', query: param})


}

const countData = ref({})
const getCountData = (id) => {
    let param = {
        platformId: id
    }
    proxy.$http.post('/gdsti2/web/a/webResource/instrumentDataCount',param).then(res => {
        if (res.data.state === 0) {
            countData.value = res.data.result;
        }
    }).catch(err => {
    });
}

//仪器目录级联选择器数据目录
const cascaderOptions = ref([])
const typeLoading = ref(false)

const instrumentSearchForm = reactive({
    catalogTreeCode: '',
    catalogType: 'INSTRUMENT_DATA',
    cname: '',

})

//查询仪器目录
const getCatalogTree = () => {
    typeLoading.value = true;
    proxy.$http.post('/gdsti2/web/a/webResource/catalogTree.do?isOpen=ALL&catalogType=INSTRUMENT_DATA').then(res => {
        if (res.data.state === 0) {
            cascaderOptions.value = res.data.result;
        }
        typeLoading.value = false;
    }).catch(err => {
        typeLoading.value = false;
    });
}

//已点击的树节点名称
const treeClickNodeName = ref('')
//树节点点击
const handleNodeClick = (data,node,nodeItem) => {
    instrumentSearchForm.catalogTreeCode = data.treeCode;
    treeClickNodeName.value = data.nodeName;
    getResList();
}
//已点击数节点标签移除
const nodeNameClose = (tag) => {
    //不管三七二十一，清空
    treeClickNodeName.value =  '';
    instrumentSearchForm.catalogTreeCode = '';
    getResList();
}


//资源查询结果
const resListResult = ref({})

//页码
const currentPage = ref(1)

//查询仪器数据
const getResList = () => {
    resLoading.value = true;


    instrumentSearchForm.limit = 10;
    instrumentSearchForm.offset = (currentPage.value-1)*10;
    if(route.query && route.query.id){
        instrumentSearchForm.platformId = route.query.id;
    }


    proxy.$http.post('/gdsti2/web/a/webResource/resourceDataList',instrumentSearchForm).then(res => {
        if (res.data.state == 0) {
            if(res.data.state === 0){
                resListResult.value = res.data.result;
            }
        }
        resLoading.value = false;
    }).catch(err => {
        resLoading.value = false;
    });
}



const gotoDetail = (item) => {
    let param = {
        id: item.id,
        catalogType: item.catalogType
    }
    proxy.$router.push({path: '/zhaoqing/zhaoqingInstrumentInfo', query: param})
}


//城市选择
const areaOptions = ref(city.cityList);

const getCityNameByCodee = (code) => {
    for (let i = 0; i < areaOptions.value.length; i++) {
        if (areaOptions.value[i].code === code) {
            return areaOptions.value[i].value;
        }
    }
}

//资源目录树节点配置
const treeProps = {
    children: 'children',
    label: 'catalogName',
    value: 'id'
}

const pageChange = (index) => {
    currentPage.value = index;
    getResList();
}


const route = useRoute();
onMounted(()=>{
    console.log(route.query)
    if(route.query && route.query.id){
        getInfo(route.query.id);
        getCountData(route.query.id);
    }
    getCatalogTree();
});


</script>

<style lang="less" scoped>


.text-center{
    text-align: center;
}



.platform-content-box{
    background: linear-gradient(180deg, #FFFFFF 0%, #F6F9FF 100%);
    background-size: 100% 600px;
    background-repeat: no-repeat;
    padding: 15px 20px;
    border-radius: 10px;
    margin-top: 15px;

    min-height: 600px;
}





.scrollbar-demo-item{

    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    margin: 10px;
    text-align: center;
    border-radius: 4px;
    background: var(--el-color-primary-light-9);
    color: var(--el-color-primary);
}

.platform-info-name{
    font-family: 思源黑体;
    font-size: 18px;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0px;
    color: #1B66FC;
}
.platform-info-field{
    font-family: 思源黑体;
    font-size: 14px;
    font-weight: normal;
    line-height: normal;
    color: rgba(0, 0, 0, 0.85);
    margin-right: 27px;
}
.platform-count{
    font-family: 思源黑体;
    font-size: 20px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0px;
}
.platform-info-desc{
    color: #A5A5A5;
    font-family: 思源黑体;
    font-size: 12px;
    font-weight: normal;
    line-height: 14px;
    letter-spacing: 0px;
}
.platform-info-box{
    height: 100px;
    overflow: hidden; /* 1. 隐藏超出内容 */
    text-overflow: ellipsis; /* 2. 超出部分显示省略号 */
    display: -webkit-box; /* 3. 将元素转为弹性伸缩盒子模型 */
    -webkit-line-clamp: 4; /* 4. 关键属性：限制显示的行数，比如2行就写2，3行写3 */
    -webkit-box-orient: vertical; /* 5. 关键属性：设置伸缩盒子的子元素排列方式为垂直 */
}

.platform-title{
    font-family: 思源黑体;
    font-size: 30px;
    font-weight: bold;
    line-height: normal;
    letter-spacing: 0px;
}
.platform-desc{
    font-family: 思源黑体;
    font-size: 14px;
    font-weight: normal;
    line-height: 24px;
    margin-top: 10px;


    overflow: hidden; /* 1. 隐藏超出内容 */
    text-overflow: ellipsis; /* 2. 超出部分显示省略号 */
    display: -webkit-box; /* 3. 将元素转为弹性伸缩盒子模型 */
    -webkit-line-clamp: 3; /* 4. 关键属性：限制显示的行数，比如2行就写2，3行写3 */
    -webkit-box-orient: vertical; /* 5. 关键属性：设置伸缩盒子的子元素排列方式为垂直 */
}
.platform-get-button{
    margin-top: 10px;
}

.platform-card{
    display: flex;
}
.platform-card-content{
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    padding: 15px;
    display: flex;
    width: 300px;

    box-shadow: 0px 2px 6px 0px #E8F6F2;
}
.platform-card-content:hover{
    cursor: pointer;

}

.platform-card-content:not(.active) {
    background: linear-gradient(119deg, #F3F9FF 15%, #E8F6F2 53%);

}
.platform-card-content.active{
    background-color: #61CFAF;
    color: white;
}

.platform-card-desc{
    font-family: Source Han Sans;
    font-size: 18px;
    font-weight: normal;
    line-height: 26px;
    letter-spacing: 0.55px;
    /* 正文色/正文辅助色 */
    //color: #767676;
}

.res-content-box{
    background: linear-gradient(180deg, #FFFFFF 0%, #F6F9FF 100%);
    background-size: 100% 600px;
    background-repeat: no-repeat;
    margin-top: 25px;
    padding: 15px 20px;
    border-radius: 10px;
}

.instrument-title{
    color: white;
    height: 30px;
    font-size: 18px;
    display:flex;
    align-items: flex-end;
    padding: 5px 15px;

    background: #61CFAF;
}
.instrument-name-index{
    color: white;
    background-color: #959595;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 50%;
    display: inline-block;
}
.instrument-name{
    padding: 3px 10px;
    white-space: nowrap;    /* 强制文本在一行显示，不换行 */
    overflow: hidden;       /* 隐藏超出容器的文本内容 */
    text-overflow: ellipsis;/* 超出的文本用省略号「...」替代 */
}
.instrument-name:hover{
    cursor: pointer;
}



.instrument-info-name{
    font-family: 思源黑体;
    font-size: 18px;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0px;
    color: #61CFAF;
}

.instrument-info-field{
    font-family: 思源黑体;
    font-size: 14px;
    font-weight: normal;
    line-height: normal;
    color: rgba(0, 0, 0, 0.85);
    margin-right: 27px;
}
.instrument-info-name:hover{
    cursor: pointer;
}
</style>

